import { Articulo } from "../articulo/articulo"
import { TipoCliente } from "../cliente/tipocliente/tipoCliente"

export class Filtros {
    tipos_cliente: TipoCliente[]
    tipos_articulo: Articulo[]
}

